import { MilitaryTech } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { useState } from "react";
import { User } from "../../../../app/backendTypes";
import TableauSiteRoleDialog from "./TableauSiteRoleDialog";
import { useTableauUserSiteRole } from "../../../../app/hooks";

export default function TableauSiteRoleAction(props: { user: User }) {
  const { user } = props;

  const [open, setOpen] = useState(false);

  const { role, reload } = useTableauUserSiteRole(user.employee.id);

  return (
    <>
      {role !== null && (
        <Chip
          icon={<MilitaryTech />}
          variant="outlined"
          color="secondary"
          label={role}
          onClick={() => setOpen(true)}
        />
      )}

      <TableauSiteRoleDialog
        open={open}
        setOpen={setOpen}
        user={user}
        onRoleChange={reload}
      />
    </>
  );
}
